import { render, staticRenderFns } from "./PaginaContratti.vue?vue&type=template&id=6ba4533e"
import script from "./PaginaContratti.vue?vue&type=script&lang=js"
export * from "./PaginaContratti.vue?vue&type=script&lang=js"
import style0 from "./PaginaContratti.vue?vue&type=style&index=0&id=6ba4533e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports